<template>
  <div class="gfr-dropdown-item">
    <slot />
  </div>
</template>
<script lang="ts" setup></script>
